interface V3IconSortProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconSort = ({ }: V3IconSortProps) => <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 6.64714L4.66667 3.98047M4.66667 3.98047L7.33333 6.64714M4.66667 3.98047V13.3138" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.0001 10.6471L11.3334 13.3138M11.3334 13.3138L8.66675 10.6471M11.3334 13.3138V3.98047" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>

